import React from 'react'
import { T } from '@transifex/react'

interface Props {
  name: string
}

export const SalesPersonInfo: React.FC<Props> = ({ name }) => {
  return (
    <div className="vd-mt4 vd-mb4">
      <strong>
        <T _str="Sold by" />
      </strong>
      <span style={{ wordBreak: 'break-word' }}>{` ${name}`}</span>
    </div>
  )
}
